import { formatCurrency } from "@gymflow/helpers";
import { InvoiceNewDTO } from "@gymflow/types";
import { DateTime } from "luxon";

import { usePortalRoutes } from "../../../../hooks";
import { useClubSettings } from "../../../../providers";
import { RouteFeature } from "../../../../routes";
import { Button, ChevronRightIcon } from "../../../atoms";
import { HostedPagesCard } from "../../components/HostedPagesCard";
import { InvoiceBadge } from "./InvoiceBadge";

export type HostedPagesReceiptCardProps = {
  invoice: InvoiceNewDTO;
};

export const HostedPagesReceiptCard = ({
  invoice,
}: HostedPagesReceiptCardProps) => {
  const { createSiteOrEmbedLink } = usePortalRoutes();
  const settings = useClubSettings();
  return (
    <HostedPagesCard.Container className="p-2">
      <HostedPagesCard.Header>
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-1 flex-row flex-wrap items-center justify-between gap-y-0.5">
            <div className="flex flex-row flex-wrap items-center gap-x-1.5 gap-y-0.5">
              <div className="dark:text-gray-25 text-base font-bold text-gray-950">
                {formatCurrency(invoice.totalAmount, settings.defaultCurrency)}
              </div>
              <InvoiceBadge invoice={invoice} size="xs" />
            </div>
            <div className="text-xs font-medium text-gray-500 dark:text-gray-400">
              {DateTime.fromISO(invoice.issueDate).toLocaleString(
                DateTime.DATE_MED,
              )}
            </div>
          </div>
          <Button
            className="self-start p-0 pt-0.5"
            link={createSiteOrEmbedLink(
              RouteFeature.SiteProfileReceiptOverview.replace(
                ":invoiceNumber",
                invoice.number,
              ),
            )}
            intent="transparent"
            size="icon"
          >
            <ChevronRightIcon
              className="size-5"
              pathClassName="stroke-gray-500 dark:stroke-gray-400"
            />
          </Button>
        </div>
      </HostedPagesCard.Header>
    </HostedPagesCard.Container>
  );
};
